/**
 * Small formatting helpers so the UI code stays declarative.
 */

/** "in 28 minutes", "in 5 seconds", "now", or "just now". */
export function humanizeRelative(
  isoWhen: string,
  now: Date = new Date(),
): string {
  const when = Date.parse(isoWhen);
  if (Number.isNaN(when)) return '';
  const diffSec = Math.round((when - now.getTime()) / 1000);
  const abs = Math.abs(diffSec);
  if (abs < 5) return diffSec >= 0 ? 'now' : 'just now';
  const units: Array<[number, string]> = [
    [60, 'second'],
    [60, 'minute'],
    [24, 'hour'],
    [7, 'day'],
    [4.345, 'week'],
    [12, 'month'],
    [Number.POSITIVE_INFINITY, 'year'],
  ];
  let value = abs;
  let label = 'second';
  for (let i = 0; i < units.length; i += 1) {
    const [divisor, name] = units[i]!;
    if (value < divisor) {
      label = name;
      break;
    }
    value = value / divisor;
    label = units[i + 1]?.[1] ?? name;
  }
  const rounded = Math.round(value);
  const plural = rounded === 1 ? '' : 's';
  return diffSec >= 0
    ? `in ${rounded} ${label}${plural}`
    : `${rounded} ${label}${plural} ago`;
}

/** mm:ss — useful for the recording timer. */
export function formatDuration(totalMs: number): string {
  const totalSec = Math.max(0, Math.floor(totalMs / 1000));
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}
